/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 873
// module chunks = 0